<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;reports.microsoft.custom_powershell_reports.form.about' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <ziro-custom-powershell-queries-form
        [report]="report"
        [allReportNames]="allReportNames"
      ></ziro-custom-powershell-queries-form>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
